// utils/FeatureAccess.js
const packageFeatures = {
  basic: {
    schedule: false,
    invoices: false,
    payments: false,
    products: false,
    healthForms: true,
    fiskalizim: false,
    reports: false,
    suppliers: false,
  },
  standard: {
    schedule: true,
    invoices: true,
    payments: true,
    products: true,
    healthForms: true,
    fiskalizim: true,
    reports: true,
    suppliers: false,
  },
  g: {
    schedule: true,
    invoices: true,
    payments: true,
    products: true,
    healthForms: true,
    fiskalizim: true,
    finance: true,
    laboratory: true,
    reports: true,
    suppliers: true,
  },
};

export const isFeatureAllowed = (packageType, feature) => {
  return packageFeatures[packageType]?.[feature] === true || false;
};
